export type PlanDescription = {
  description: string;
  features: string[];
  limitations?: string[];
  comingSoon?: boolean;
};

export const PLAN_DESCRIPTIONS: Record<string, PlanDescription> = {
  DEGUSTER: {
    description: 'Comece grátis, sem compromisso',
    features: [
      // 'Busca inteligente com I.A.',
      'Fotos, nome, preço e descrições',
      'Carregamento ultrarrápido',
      'Link compartilhável do cardapio',
      'Até 30 pedidos/mês grátis (depois R$ 1,20 por excedente)',
    ],
  },
  GOURMET: {
    description: 'Ideal para restaurantes em crescimento',
    features: [
      'Tudo do plano Deguster',
      'Até 400 pedidos/mês grátis (depois R$ 0,90 por excedente)',
      'Atualização em tempo real do pedido',
      'Gráfico de receita mensal',
      'Configuração de produtos personalizados',
      'Importar cardápio com I.A',
      'Subdominio personalizado',
      'Fidelidade de pontos (Em breve)'
    ],
  },
  BANQUET: {
    description: 'Para comerciantes que querem se destacar com a agilidade',
    features: [
      'Tudo do Gourmet',
      'Até 1.000 pedidos/mês grátis (depois R$ 0,60 por excedente)',
      'Customização de identidade visual (Cores, logo e slogan)',
      'Gestor de cozinha KDS',
      'Integração WhatsApp (Em breve)',
    ],
  },
  TWOHDSC: {
    description: 'Plano de teste interno — mesmas features do Gourmet',
    features: [
      'Tudo do plano Gourmet',
      'R$ 5,00/mês (teste de pagamento)',
      'Uso exclusivo interno',
    ],
  },
  // CHEFS_SPECIAL: {
  //   description: 'A solução completa (Em breve)',
  //   features: [
  //     'Tudo do Banquete',
  //     'Analytics avançado (Em breve)',
  //     'Sugestão de preços com IA (Em breve)',
  //     'Notificações (Em breve)',
  //     'PWA nativo (Em breve)',
  //     'Integração com PDV',
  //   ],
  // },
};
